<template>
  <div class="popularProducts component-padding">
    <b-container fluid>
      <div class="component-container">
        <div class="m-auto text-center">
          <h3 class="component-title-cont">
            <span class="component-title">{{title}}</span>
          </h3>
        </div>
        <carousel class="row" :per-page="3" autoplay navigationEnabled>
          <slide class="col-4" v-for="(data,index) in popularProducts.slice(0, 12)" :key="index">
            <div @click="goTodetail(data.productId)" class="product-item">
              <div class="product-item-cont">
                <img
                  :src="require('@/assets/images/' + data.image)"
                  :alt="data.image"
                  class="product-item-img"
                />
                <div class="product-item-btn">დეტალურად</div>
              </div>
              <h3 class="product-item-title">{{data.productTitle}}</h3>
              <p class="product-item-price">{{data.price}}</p>
            </div>
          </slide>
        </carousel>
      </div>
      <div class="component-container">
        <div class="m-auto text-center">
          <h3 class="component-title-cont">
            <span class="component-title">{{newsTitle}}</span>
          </h3>
        </div>
        <carousel class="row" :per-page="3" autoplay navigationEnabled>
          <slide class="col-4" v-for="(data,index) in lastProducts.slice(0, 12)" :key="index">
            <div @click="goTodetail(data.productId)" class="product-item">
              <div class="product-item-cont">
                <img
                  :src="require('@/assets/images/' + data.image)"
                  :alt="data.image"
                  class="product-item-img"
                />
                <div class="product-item-btn">დეტალურად</div>
              </div>
              <h3 class="product-item-title">{{data.productTitle}}</h3>
              <p class="product-item-price">{{data.price}}</p>
            </div>
          </slide>
        </carousel>
      </div>
    </b-container>
  </div>
</template>

<script>
import productsJson from "@/json/db.json";
export default {
  name: "popularProducts",
  data() {
    return {
      title: "პოპულარული პროდუქტები",
      newsTitle: "უახლესი პროდუქტები"
    };
  },
  methods: {
    goTodetail(prodId) {
      this.$router.push({ name: "details", params: { Pid: prodId } });
    }
  },
  computed: {
    products() {
      return productsJson.products.map(item => {
        return item;
      });
    },
    popularProducts() {
      return this.products.filter(i => i.rating === "5");
    },
    lastProducts() {
      return this.products
        .slice()
        .sort((a, b) => new Date(b.date) - new Date(a.date));
    }
  }
};
</script>

<style lang="scss">
@import "../styles/global";
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css");

.component {
  &-padding {
    padding: 1vh;
  }
  &-container {
    margin-bottom: 5vh;
  }
  &-title {
    font-size: $font-lg;
    font-family: $fontALKSanet;
    color: $skyblueLight;
    &-cont {
      margin: 0 auto 5vh;
    }
    &-link {
      transition: 0.3s;
      &:hover {
        text-decoration: none;
        color: $skyblueLight;
        opacity: 0.8;
      }
    }
  }
}
.product-item {
  cursor: pointer;
  text-align: center;
  &-cont {
    position: relative;
    overflow: hidden;
  }
  &-img {
    width: 100%;
    height: 16vh;
    object-fit: cover;
    position: relative;
    transition: 0.5s ease;
  }
  &-btn {
    position: absolute;
    bottom: -10vh;
    padding: 2vh 7vh;
    transition: 0.5s ease;
    opacity: 0;
    width: 100%;
  }
  &-title {
    font-family: $fontDejaVuSans;
    font-size: $font-sm;
    margin-top: 1vh;
  }
  &-price {
    font-family: $fontDejaVuSans;
    font-size: $font-sm;
  }
}
.VueCarousel-dot {
  margin: 2vh 1vh !important;
  width: 1vh !important;
  height: 1vh !important;
  background: $greyLight !important;
  padding: 5px !important;
  &--active {
    background-color: $skyblueLight !important;
    outline: none !important;
  }
  &:focus {
    outline: none !important;
  }
}
.VueCarousel-navigation {
  display: none;
}
.VueCarousel-navigation-prev,
.VueCarousel-navigation-next {
  visibility: hidden;
  padding: 0 !important;
  margin: 0 !important;
  top: 33% !important;
  transform: translateX(-50%) !important;
  &::after {
    font-size: 5vh;
    color: #fff;
    display: inline-block;
    font-weight: 900;
    visibility: visible;
  }
}
.VueCarousel-navigation-prev::after {
  font-family: "Font Awesome 5 Free";
  content: "\f053";
  position: absolute;
  left: 0;
  transform: translateX(-50%);
}
.VueCarousel-navigation-next::after {
  font-family: "Font Awesome 5 Free";
  content: "\f054";
  position: absolute;
  right: auto;
}
.VueCarousel-slide{
  padding: 0 0.5vh;
}
/* =========== Responsive */

@media screen and (min-width: 768px) {
  .component {
    &-padding {
      padding: 5vh;
    }
  }
  .product-item {
    &:hover .product-item-btn {
      opacity: 1;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.7);
    }
    &-img {
      height: 55vh;
    }
    &-title {
      font-size: $font-md;
    }
    &-price {
      font-size: $font-md;
    }
  }
  .VueCarousel-navigation {
    display: block;
  }
  .VueCarousel-slide{
    padding: 0 2vh;
  }
}
</style>